import axios from "axios";
import { auth } from "helpers/firebase";

axios.defaults.baseURL = "https://asia-northeast1-careu-22d80.cloudfunctions.net";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

// axios.defaults.headers.common['token'] = auth.currentUser.getIdToken(true);
export const findUser = async (params) => {
  return axios.post("/findUser", params, {
    headers: { token: await auth.currentUser.getIdToken(true) }
  })
    .then(res => res.data);
}

export const createUser = async (params) => {
  return axios.post("/createUser", params, {
    headers: { token: await auth.currentUser.getIdToken(true) }
  })
    .then(res => res.data);
}

export const setupMember = async (params) => {
  return axios.post("/setupMember", params, {
    headers: { token: await auth.currentUser.getIdToken(true) }
  })
    .then(res => res.data);
}

export const deleteMember = async (params) => {
  return axios.post("/deleteMember", params, {
    headers: { token: await auth.currentUser.getIdToken(true) }
  })
    .then(res => res.data);
}

export const changePassword = async (params) => {
  return axios.post("/changePassword", params, {
    headers: { token: await auth.currentUser.getIdToken(true) }
  })
    .then(res => res.data);
}


// DEPRECATED: use local storage version
export const selectOrg = async (org_id) => {
  return axios.post("/selectOrg", { org_id }, {
    headers: { token: await auth.currentUser.getIdToken(true) }
  })
    .then(res => res.data);
}

export const createOrg = async (params) => {
  return axios.post("/createOrg", params)
    .then(res => res.data);
}

export const getUsers = async () => {
  return axios.post("/getUsers", {}, {
    headers: { token: await auth.currentUser.getIdToken(true) }
  })
    .then(res => res.data);
}